import React, { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { getCtaVariant } from "../../lib/ab";

/**
 * Sticky "Get a Quote" CTA with built-in A/B label test.
 * - Variant A: "Get a Shoot Quote"  | Variant B: "Estimate My Shoot"
 *   Assignment is persistent per-visitor via localStorage.
 * - Appears once user scrolls past hero (configurable, default 700px).
 * - Auto-hides when the #enquiry section enters the lower half of the viewport.
 */
export const StickyQuoteCTA = ({ href = "#enquiry", showAfter = 700 }) => {
  const [visible, setVisible] = useState(false);
  const [variant, setVariant] = useState(null);

  useEffect(() => {
    setVariant(getCtaVariant());
  }, []);

  useEffect(() => {
    const onScroll = () => {
      const passedHero = window.scrollY > showAfter;
      let nearEnquiry = false;
      const enquiry = document.getElementById("enquiry");
      if (enquiry) {
        const rect = enquiry.getBoundingClientRect();
        nearEnquiry = rect.top < window.innerHeight - 200;
      }
      setVisible(passedHero && !nearEnquiry);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [showAfter]);

  if (!variant) return null;

  return (
    <div
      aria-hidden={!visible}
      data-testid="sticky-quote-cta"
      data-cta-variant={variant.id}
      className={`fixed z-40 pointer-events-none transition-all duration-500 ease-out
        ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}
        bottom-4 right-4 sm:bottom-6 sm:right-6`}
    >
      <a
        href={href}
        data-testid="sticky-quote-link"
        className="pointer-events-auto group inline-flex items-center gap-3 bg-ember hover:bg-ember-deep text-bone font-sans font-bold uppercase tracking-wider2 text-xs sm:text-sm px-5 sm:px-6 py-3.5 sm:py-4 shadow-2xl shadow-ink/40 border border-ember hover:border-ember-deep transition-colors"
      >
        <span>{variant.label}</span>
        <ArrowUpRight
          size={14}
          strokeWidth={2}
          className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        />
      </a>
    </div>
  );
};

export default StickyQuoteCTA;
